import { cx } from '@emotion/css';
import { FC, forwardRef, HTMLProps, ReactNode } from 'react';

interface CheckboxProps extends HTMLProps<HTMLInputElement> {
  htmlFor: string;
  children?: ReactNode;
  containerProps?: HTMLProps<HTMLLabelElement>;
}

export const Checkbox: FC<React.PropsWithChildren<CheckboxProps>> = forwardRef(({ containerProps, children, htmlFor, ...props }, ref) => {
  return (
    <label
      htmlFor={htmlFor}
      {...containerProps}
      className={cx('flex flex-row items-baseline gap-2 stihl-text-body-default-reg', containerProps?.className)}
    >
      <input {...props} type="checkbox" ref={ref} id={htmlFor} className={cx('shrink-0', props.className)} />
      {children}
    </label>
  );
});
